@if ((mode$|async); as mode) {
  <div class="mt-10">
    <h2 class="text-lg font-medium mb-2">{{title}}</h2>
    @if (editText) {
      <div>
        <vwui-textarea [formControl]="projectDescriptionFormControl" [rows]="10"></vwui-textarea>
        <div class="flex">
          <vwui-button class="is-primary mr-1" (click)="saveText()">Opslaan</vwui-button>
          <vwui-button class="is-light-primary" (click)="closeTextEditor()">Annuleren</vwui-button>
        </div>
      </div>
    }
    @if (!editText) {
      <app-overflow-content
        cutoffHeight="5rem"
        [contentClass]="mode === ModeEdit ? overflowContentEditClassList : overflowContentReadClassList"
        (overflowHiddenChange)="onOverflowHiddenChange($event)">
        <div class="relative"
          [class.hover:bg-neutral-4]="!editText && mode === ModeEdit"
          [class.cursor-pointer]="!editText && mode === ModeEdit"
          (click)="openTextEditor(mode)">
          <app-copy-to-clipboard [value]="text || '-'">
            <p [class.line-clamp-3]="overflowHidden" [innerHTML]="(text || '-') | nl2br"></p>
          </app-copy-to-clipboard>
          @if (!editText && mode === ModeEdit) {
            <vwui-icon class="absolute top-1/2 transform -translate-y-1/2 right-4 w-4 h-4 text-neutral-1" iconName="vwui-edit"></vwui-icon>
          }
        </div>
      </app-overflow-content>
    }
  </div>
}
